export default "__VITE_ASSET__OQNPM33c__"